module.exports = __webpack_public_path__ + "img/network.6dfa5655.png";